import { Injectable, ElementRef } from '@angular/core';

@Injectable()
export class DDAService {
  main: ElementRef;
  basket: ElementRef;

  constructor() {}
}
